//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import TextAlign from '@tiptap/extension-text-align'

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import MenuBar from "beaktShared/components/TipTap/MenuBar";
import HeaderStepCampanha from './HeaderStepCampanha';

// services

import { UsePutApi,UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);

export default function ConclusaoCampanha({ item, handleStepAnterior, handleFinalizar, disabledform }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { register, handleSubmit, setValue } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 4000);
    };
    const [campanhaId, setcampanhaId] = React.useState(0);

    const [total_clientesContato, settotal_clientesContato] = React.useState(0);
    const [total_descartes, settotal_descartes] = React.useState(0);
    const [total_representatividade, settotal_representatividade] = React.useState(0);
    const [total_clientesEmail, settotal_clientesEmail] = React.useState(0);
    const [total_clientesCelular, settotal_clientesCelular] = React.useState(0);
    const [total_clientesFacebook, settotal_clientesFacebook] = React.useState(0);
    const [total_clientesInstagram, settotal_clientesInstagram] = React.useState(0);
    const [total_clientesEndereco, settotal_clientesEndereco] = React.useState(0);
    const html = item.corpoEmail;

    useEffect(() => {
        if (item.clientesExibicao != null) {
            let clientesTotal = item.clientesExibicao.length;
            let clientesDescartados = item.clientesExibicao.filter(obj => obj.descartado == true).length;
            let clientesRepresentatividade = "R$ " + item.clientesExibicao.reduce((a, c) => a = a + c.ticketMedio, 0).toFixed(2).replace('.', ',');
            let clientesEmail = item.clientesExibicao.filter(obj => obj.email != "").length;
            let clientesCelular = item.clientesExibicao.filter(obj => obj.celular != "").length;
            let clientesFacebook = item.clientesExibicao.filter(obj => obj.linkFacebook != "").length;
            let clientesInstagram = item.clientesExibicao.filter(obj => obj.linkInstagram != "").length;
            let clientesEndereco = item.clientesExibicao.filter(obj => obj.rua != "").length;

            setcampanhaId(item.campanhaId);
            settotal_clientesContato(clientesTotal);
            settotal_descartes(clientesDescartados);
            settotal_representatividade(clientesRepresentatividade);
            settotal_clientesEmail(clientesEmail);
            settotal_clientesCelular(clientesCelular);
            settotal_clientesFacebook(clientesFacebook);
            settotal_clientesInstagram(clientesInstagram);
            settotal_clientesEndereco(clientesEndereco);
            if (item.assuntoEmail != "") {
                setValue('assuntoemail', item.assuntoEmail);
                setValue('corpoemail', item.corpoEmail);
            }
        }
    }, [item]);

    // Carrega editor de email
    const _editor = useEditor({
        extensions: [
            StarterKit,
            Document,
            Text,
            TextAlign.configure({
                types: ['heading', 'paragraph'],
            }),
        ],
        editable: disabledform ? false : true,
        content: item.corpoEmail,
    })

    //voltar step Identificacaocampanha 
    const handleReturnForm = () => {
        handleStepAnterior(item);
    };
    //Próximo step ConclusaoCampanha
    const [LoadingSaveForm, setLoadingSaveForm] = React.useState(false);

    const onSubmit = (data, e) => {
        e.preventDefault();

        let file = _editor.getHTML();

        if (data.assuntoemail != "") {
            if (file == "<p></p>") {
                showNotification("Preencher o corpo do email!", 'danger');
                return;
            }
            else {
                item.assuntoEmail = data.assuntoemail;
                item.corpoEmail = file;
            }
        }
        else{
            item.assuntoEmail = "";
        }

        if(file != "<p></p>"){
            if (data.assuntoemail == "") {
                showNotification("Preencher o assunto do email!", 'danger');
                return;
            }
            else {
                item.assuntoEmail = data.assuntoemail;
                item.corpoEmail = file;
            }
        }
        else{
            item.corpoEmail = "";
        }

        let clientescampanha = [];

        item.clientesExibicao.map(obj => {
            clientescampanha.push({
                CampanhaClienteId: 0,
                CampanhaId: campanhaId,
                ClienteId: obj.clienteId,
                Descartado: obj.descartado
            });
        });

        item.campanhaClientes = clientescampanha;
        setLoadingSaveForm(true);
        if(item.campanhaId != 0){
            let endpointPut =  "campanhas/" + "altercampanha/"
            UsePutApi(endpointPut,item.campanhaId, item).then(result => {
                if (result.status !== 200) {
                    setLoadingSaveForm(false);
                    showNotification(result.message.message, 'danger');
                    return false;
                }
                setLoadingSaveForm(false);
                handleFinalizar(result.message);
                return true;
            });
        }
        else{
            let endPointPost = "campanhas/" + "savecampanha/"
            UsePostApi(endPointPost, item).then(result => {
                if (result.status !== 200) {
                    setLoadingSaveForm(false);
                    showNotification(result.message.message, 'danger');
                    return false;
                }
                setLoadingSaveForm(false);
                handleFinalizar(result.message);
                return true;
            });
        }

    }

    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />
            <HeaderStepCampanha etapa={2}></HeaderStepCampanha>

            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12}>
                        <Card>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_clientesContato != null ? total_clientesContato : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_contacts')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_descartes != null ? total_descartes : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_discards')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_representatividade != null ? total_representatividade : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_representativeness')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_clientesEmail != null ? total_clientesEmail : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_email_contacts')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_clientesCelular != null ? total_clientesCelular : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_cell_contacts')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_clientesFacebook != null ? total_clientesFacebook : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_facebook_contacts')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_clientesInstagram != null ? total_clientesInstagram : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_instagram_contacts')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} lg={3}>
                                        <div className="cardT">
                                            <div>
                                                <h5>
                                                    {total_clientesEndereco != null ? total_clientesEndereco : 0}
                                                </h5>
                                            </div>
                                            <div className="ico">
                                                <Assignment style={{ fontSize: '35px' }} />
                                            </div>
                                            <div style={{ clear: 'both' }}></div>
                                            <label>{t('label.total_address_contacts')} </label><br /><br />
                                        </div>
                                    </GridItem>
                                </GridContainer>
                                <br></br>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div className="subTitulo">
                                            <h6>{t('label.sending_email')} </h6>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('label.email_subject')}
                                                variant="outlined"
                                                defaultValue=""
                                                disabled={disabledform}
                                                name="assuntoemail"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: false })}

                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        {disabledform && <label>{t('label.email_body') + ":"} </label>}
                                        <div style={{ "height": "300px", "border": "1px solid #999999", "border-radius": "5px", "padding": "10px", "overflow-y": "auto" }}>
                                            {!disabledform && <MenuBar editor={_editor}> </MenuBar>}
                                            <EditorContent editor={_editor} style={{ "width": "100%" }} name="corpoemail"></EditorContent>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <Button onClick={() => handleReturnForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('label.return')}
                        </Button>
                        {!disabledform &&
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')} {LoadingSaveForm && <div> ... {t('label.loading')}</div>}
                            </Button>}
                    </GridItem>
                </GridContainer>
            </form>

        </div>
    );
}